<span class="pi-container"
      [ngClass]="method | lowercase"></span>